import { VChip } from 'vuetify/lib/components/VChip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.rules.length > 0 ? _c('div', {
    staticClass: "search-tag-list"
  }, _vm._l(_vm.rules, function (rule, index) {
    return _c(VChip, {
      key: rule.id,
      attrs: {
        "small": _vm.small,
        "data-cy": "search_chip",
        "close": !_vm.readonly
      },
      on: {
        "click:close": function ($event) {
          return _vm.removeRule(index);
        }
      }
    }, [[_vm._v("\n      " + _vm._s(_vm.getRuleCategoryWithCondition(rule)) + ": \n      "), _c('strong', [_vm._v(_vm._s(_vm.getRuleValue(rule)))])]], 2);
  }), 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };